import React, { Component } from 'react';
import radium, { Style } from 'radium';
import Relay from 'react-relay/classic';
import { getItemInfo } from 'components/ItemFetch';
import Icon from '../../../../helper/Icon';

class PeerQuestionItem extends Component {
  static styles = {};

  getNetScore(reviewsReceived) {
    const ratingArray = reviewsReceived.map(reviewReceived => reviewReceived.review.rating);
    const sum = ratingArray.reduce((a, b) => a + b, 0);
    return sum / ratingArray.length;
  }

  renderPeerScore(index, rating, isAnonymous, reviewerId, lastItem, maxScore, actorType) {
    const styles = PeerQuestionItem.styles;
    const reviewerName = getItemInfo(
      'users',
      reviewerId,
      'name',
      () => {
        this.forceUpdate();
      },
      '...'
    );
    const actorTypeText = actorType && actorType !== 'user' ? actorType.toUpperCase() : '';
    return (
      <div style={styles.peerReviewText}>
        {isAnonymous ? 'Peer ' + index : reviewerName}
        {' '}
        {actorTypeText && (
          <span
            style={{
              display: 'inline-block',
              fontSize: '12px',
              letterSpacing: '0.9px',
              color: '#929fae',
              fontWeight: 600
            }}
          >
            (
            {actorTypeText}
            {' '}
REVIEW)
          </span>
        )}
        :
        {' '}
        {rating}
/
        {maxScore}
        {!lastItem ? ', ' : null}
      </div>
    );
  }

  renderNetScore(reviewsReceived, maxScore) {
    const styles = PeerQuestionItem.styles;
    if (reviewsReceived.length < 1) return null;
    return (
      <span style={styles.netScoreText}>
        Net Score:
        {' '}
        {Math.round(this.getNetScore(reviewsReceived))}
/
        {maxScore}
      </span>
    );
  }

  renderResponseCircle(reviewsReceived) {
    const styles = PeerQuestionItem.styles;
    if (reviewsReceived.length < 1) return null;
    return (
      <div className="userCircleContainer" style={[styles.displayFlexRow]}>
        {reviewsReceived.map(index => (
          <span
            className="userImageContainer"
            style={[
              styles.displayFlexRow,
              styles.alignItemsCenter,
              { zIndex: reviewsReceived.length - index }
            ]}
          >
            <Icon icon="person" size="25px" fill="#dbe2e8" />
          </span>
        ))}
      </div>
    );
  }

  renderTextView(userId, index, isAnonymous, responseText, lastItem) {
    const styles = PeerQuestionItem.styles;
    const reviewerName = getItemInfo(
      'users',
      userId,
      'name',
      () => {
        this.forceUpdate();
      },
      '...'
    );
    return (
      <div
        style={[
          styles.textViewContainer,
          styles.displayFlexColumn,
          !lastItem ? styles.marginBottom16 : null
        ]}
      >
        <div
          style={[
            styles.peerName,
            styles.displayFlexRow,
            styles.alignItemsCenter,
            styles.contentSpaceBetween
          ]}
        >
          <span>
            {isAnonymous ? 'Peer ' + index : reviewerName}
:
          </span>
          <span
            className="userImageContainer"
            style={[styles.displayFlexRow, styles.alignItemsCenter]}
          >
            <Icon icon="person" size="25px" fill="#dbe2e8" />
          </span>
        </div>
        <div style={styles.responseText}>{responseText}</div>
      </div>
    );
  }

  renderCheckBox(selected) {
    const styles = PeerQuestionItem.styles;
    let checkBoxView = <span style={styles.normalCheckBox} />;

    if (selected) {
      checkBoxView = <span style={styles.filledCircle} />;
    }

    return checkBoxView;
  }

  renderOption(option, userResponseArray) {
    const styles = PeerQuestionItem.styles;
    const userResponseCount = userResponseArray.length;
    return (
      <div
        className="optionWrapper"
        style={[
          styles.optionWrapper,
          styles.displayFlexRow,
          styles.alignItemsCenter,
          styles.contentSpaceBetween
        ]}
      >
        <div style={[styles.optionText, styles.displayFlexRow, styles.alignItemsCenter]}>
          <div style={[styles.checkBoxContainer, styles.displayFlexRow, styles.alignItemsCenter]}>
            {this.renderCheckBox(userResponseCount > 0)}
          </div>
          {option.text}
          {' '}
(
          {option.relativeScore * this.props.rootQ.maxScore}
          {' '}
points)
        </div>
        {this.renderResponseCircle(userResponseArray)}
      </div>
    );
  }

  renderScore(rType, reviewsReceived, maxScore, options) {
    let peerView = '';
    const styles = PeerQuestionItem.styles;
    if (rType === 'text') {
      peerView = (
        <div style={styles.displayFlexColumn}>
          {reviewsReceived.map((reviewObj, index) => this.renderTextView(
            reviewObj.reviewedBy.pid,
            index + 1,
            reviewObj.review.isAnonymous,
            reviewObj.review.responseText,
            index + 1 === reviewsReceived.length
          )
          )}
        </div>
      );
    } else if (rType === 'quiz') {
      const responseTextArray = reviewsReceived.map(reviewObj => reviewObj.review.responseText);

      peerView = (
        <div style={styles.displayFlexColumn}>
          <div
            style={[
              styles.quizNetScoreRow,
              styles.displayFlexRow,
              styles.alignItemsCenter,
              styles.contentSpaceBetween
            ]}
          >
            {this.renderNetScore(reviewsReceived, maxScore)}
          </div>
          <div style={styles.quizOptionsContainer}>
            {options.map((option, index) => {
              const userResponseArray = responseTextArray.filter(text => text.indexOf(index) > -1);
              return this.renderOption(option, userResponseArray);
            })}
          </div>
        </div>
      );
    } else {
      peerView = (
        <div style={styles.displayFlexColumn}>
          <div
            style={[
              styles.netScoreRow,
              styles.displayFlexRow,
              styles.alignItemsCenter,
              styles.contentSpaceBetween
            ]}
          >
            {this.renderNetScore(reviewsReceived, maxScore)}
            {this.renderResponseCircle(reviewsReceived)}
          </div>
          <div
            className="peerReviewsContainer"
            style={[styles.peerReviewsContainer, styles.displayFlexRow, styles.alignItemsCenter]}
          >
            {reviewsReceived.map((reviewObj, index) => this.renderPeerScore(
              index + 1,
              reviewObj.review.rating,
              reviewObj.review.isAnonymous,
              reviewObj.reviewedBy.pid,
              index + 1 === reviewsReceived.length,
              maxScore,
              reviewObj.reviewedBy.actorType
            )
            )}
          </div>
        </div>
      );
    }
    return peerView;
  }

  render() {
    const styles = PeerQuestionItem.styles;
    const rootQ = this.props.rootQ;
    const index = this.props.index;
    const maxScore = rootQ.maxScore;
    const reviewsReceived = rootQ.reviewsReceived;
    return (
      <div className="peerQuestionContainer">
        <div style={styles.questionText}>
          {index + 1}
.
          {rootQ.question}
        </div>
        {this.renderScore(rootQ.rType, reviewsReceived, maxScore, rootQ.options)}

        <Style rules={styles.classBased} />
      </div>
    );
  }
}

PeerQuestionItem.styles = {
  classBased: {
    '.peerQuestionContainer': {
      marginBottom: '24px',
      paddingBottom: '20px',
      borderBottom: '1px solid #dbe2e8'
    },
    '.peerQuestionContainer:last-child': {
      marginBottom: '0px'
    },
    '.userImageContainer': {
      width: '27.4px',
      height: '27.4px',
      background: '#fff',
      boxShadow: '1px 1px 2px 0 rgba(0, 0, 0, 0.2)',
      borderRadius: '50%',
      border: '1px solid #dbe2e8',
      marginLeft: '-5px',
      justifyContent: 'center'
    },
    '.userImageContainer:first-child': {
      marginLeft: '0px'
    },
    '.optionWrapper': {
      marginBottom: '10px'
    },
    '.optionWrapper:last-child': {
      marginBottom: '0px'
    }
  },
  displayFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  displayFlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  contentSpaceBetween: {
    justifyContent: 'space-between'
  },
  questionText: {
    fontSize: '14px',
    lineHeight: '16px',
    color: '#36465d',
    marginBottom: '6px'
  },
  netScoreText: {
    fontSize: '14px',
    lineHeight: '17px',
    fontWeight: '500',
    color: '#36465d'
  },
  quizNetScoreRow: {
    margin: '6px 0 4px'
  },
  netScoreRow: {
    marginBottom: '4px'
  },
  userImageContainer: {
    width: '27.4'
  },
  peerReviewText: {
    fontFamily: 'ProximaNova',
    fontSize: '14px',
    lineHeight: '15px',
    color: '#222f42',
    marginRight: '5px'
  },
  marginBottom16: {
    marginBottom: '16px'
  },
  peerName: {
    fontSize: '14px',
    lineHeight: '16px',
    color: '#767e86',
    textTransform: 'uppercase'
  },
  responseText: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#525c65',
    paddingRight: '50px'
  },
  normalCheckBox: {
    width: '17px',
    height: '17px',
    border: '1px solid #b5bdc4',
    borderRadius: '50%',
    boxSizing: 'border-box'
  },
  filledCircle: {
    width: '12px',
    height: '12px',
    background: '#4990e2',
    borderRadius: '50%',
    border: '2px solid #fff',
    marginLeft: '1px',
    boxShadow: '0px 0 0 1px #9ea7b1'
  },
  checkBoxContainer: {
    marginRight: '11px'
  },
  optionText: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '16px',
    color: 'rgba(0, 0, 0, 0.48)'
  },
  quizOptionsContainer: {
    marginTop: '9px'
  }
};

export default Relay.createContainer(radium(PeerQuestionItem), {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: () => Relay.QL`
      fragment on PeerQuestionForReview {
          question
          rType
          maxScore
          reviewsReceived{
            review{
              rating
              responseText
              modifiedOn
              isAnonymous
            }
            reviewedBy {
              pid
              name
              picture
              actorType
            }
          }
          options {
            text
            correct
            relativeScore
          }
      }
    `
  }
});
